import BarChartPlot from '../diagrams/Barchart'
import React from 'react'
import ReactMarkdown from 'react-markdown'
import { replaceSQL } from '../utils'
import Stars from './Stars'
import remarkGfm from 'remark-gfm'
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter'
import { ghcolors, oneLight } from 'react-syntax-highlighter/dist/esm/styles/prism'

const renderers = {
  code({ node, inline, className, children, ...props }) {
    const match = /language-(\w+)/.exec(className || '')
    return !inline && match ? (
      <SyntaxHighlighter style={ghcolors} language={match[1]} PreTag="div" {...props}>
        {String(children).replace(/\n$/, '')}
      </SyntaxHighlighter>
    ) : (
      <code className={className} {...props}>
        {children}
      </code>
    )
  }
}

const ResultcardsContainer = ({
  messages,
  isLoading,
  streamCompleted,
  id,
  userId,
  userMail,
  searchContext,
  handleStatisticsClick,
  adminConfig,
  index_dep
}) => {
  return (
    <div id="result-cards-container" className="result-cards">
      {adminConfig.startMessage && (
        <>
          <div className="result-card">
            <h2>{`${'Välkommen till Stratsys AI!'}`}</h2>
            <ReactMarkdown>{adminConfig.startMessage}</ReactMarkdown>
          </div>
          <div className="result-spacer"></div>
        </>
      )}

      {messages.map((message, index) => (
        <>
          <div class="result-spacer"></div>
          <div className="query-card"> {message.query} </div>
          <div key={index} className="result-card">
            {message.answer && isLoading && index === messages.length - 1 && (
              <div className="typing-indicator-s">
                <span></span>
                <span></span>
                <span></span>
              </div>
            )}
            {(streamCompleted || index !== messages.length - 1) && (
              <div className="ai-icon">
                {
                  <>
                    <one-ux-icon set="ai" icon="ai-powered" size="400"></one-ux-icon>
                  </>
                }
              </div>
            )}
            {message.answer || streamCompleted ? (
              <ReactMarkdown remarkPlugins={[remarkGfm]} components={renderers}>
                {`${replaceSQL(message.answer)}`}
              </ReactMarkdown>
            ) : (
              <div class="typing-indicator">
                <span></span>
                <span></span>
                <span></span>
              </div>
            )}
            {/* Star rating */}
            {streamCompleted && (
              <Stars
                query={message.query}
                answer={message.answer}
                id={id}
                userId={userId}
                userMail={userMail}
                searchContext={searchContext}
                graphConfig={message.graph_config || {}}
                hasSources={message.results && message.results.length > 0}
                statsFunction={() =>
                  handleStatisticsClick(message.query, message.answer, message.results, message.summary)
                }
                index_dep={index_dep}
              />
            )}
            <div>
              {message.imageUrl && (
                <img
                  src={message.imageUrl}
                  alt="Graph couldn't be displayed. This is most likely due to that graphs aren't saved in the db."
                />
              )}
            </div>
            {message.graph && message.graph.keys.length > 0 && <BarChartPlot json={message.graph} />}
          </div>
          <div class="result-spacer"></div>
        </>
      ))}
    </div>
  )
}
export default ResultcardsContainer
